export default "__VITE_ASSET__Fxhx1HaA__"